import { createStyles, makeStyles } from '@material-ui/core';

const styles = () => createStyles({
  badge: {
    alignItems: 'flex-start',
    border: '1px solid',
    borderRadius: 4,
    display: 'inline-flex',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '16px',
    maxWidth: '100%',
    minHeight: 26,
    overflowWrap: 'break-word',
    padding: '4px 8px',
    whiteSpace: 'normal',
  },
  icon: {
    flexShrink: 0,
    fontSize: 15,
    marginRight: 5,
  },
});

export default makeStyles(styles);
